import * as React from "react";

import { Email } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";

export interface EmailButtonProps {
  email: string;
  subject?: string;
  body?: string;
}

export const EmailButton: React.FC<EmailButtonProps> = ({
  email,
  subject = "",
  body = "",
}) => {
  const href = `mailto:${email}?subject=${encodeURIComponent(
    subject,
  )}&body=${encodeURIComponent(body)}`;

  return (
    <div style={{ display: "inline-block" }}>
      <IconButton
        onClick={() => {
          window.location.href = href;
        }}
        aria-label="send email"
        size="small"
      >
        <Email color="secondary" />
      </IconButton>
      <Typography component="span">
        <a href={href} style={{ textDecoration: "none" }}>
          {email}
        </a>
      </Typography>
    </div>
  );
};
